var JSView = Control.extend({
	init: function(p) {
		this.base('div', p);
		this.setAttribute('layout', 'jsview')
		this.classList.add('jsview');
	},
	text: {
		get: function() {
			return(this.hightlightarea.text);
		},
		set: function(value) {
			this.hightlightarea.text = value;
		}
	}
});